import { render, staticRenderFns } from "./TunesGrantsRemainingTable.vue?vue&type=template&id=6623c0b7&"
import script from "./TunesGrantsRemainingTable.vue?vue&type=script&lang=ts&"
export * from "./TunesGrantsRemainingTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
